import { ExternalLink } from "@octopusdeploy/design-system-components";
import { useRef } from "react";
import { isGitHubAppTrustedFlow } from "~/areas/configuration/components/Git/getGitHubAppSettings";
import { repository } from "~/clientInstance";
interface ConfigureGitHubAppLinkProps {
    onClick?: () => void;
}
export function ConfigureGitHubAppLink({ onClick }: ConfigureGitHubAppLinkProps) {
    const installUrl = useRef(repository.GitHubApp.getInstallationUrl(window.location.href));
    const isTrustedFlow = isGitHubAppTrustedFlow();
    const handleClick = () => {
        if (!isTrustedFlow && onClick) {
            onClick();
        }
    };
    return (<ExternalLink openInSelf={isTrustedFlow} href={installUrl.current} onClick={handleClick}>
            Configure the Octopus Deploy GitHub app
        </ExternalLink>);
}
